import React from "react";
import { SparkleIcon } from "lucide-react";
const words = ["Seven Sins", "Royal Honey", "Devils Candy", "High Octane", "Spanish Fly", "Rhino Choco", "Lady in Red"];
export function BrandMarquee() {
  const loop = [...words, ...words];
  return <section aria-label="Our brands" className="overflow-hidden bg-brand py-5 text-night" data-id="element-172" data-mp="hrstb7uvbgls">
      <div className="marquee flex w-max" data-id="element-173" data-mp="mpawsiq493me">
        {loop.map((w, i) => <span key={`${w}-${i}`} aria-hidden={i >= words.length} className="flex items-center gap-8 pr-8 font-display text-2xl font-extrabold uppercase tracking-tight sm:text-3xl" data-id="element-174" data-mp="816kpxlkjqcl" data-mpi={i}>
            {w}
            <SparkleIcon className="h-5 w-5 fill-night" aria-hidden="true" data-id="element-175" data-mp="3v54doyod0h3z" />
          </span>)}
      </div>
    </section>;
}